import { render, staticRenderFns } from "./ticket_detail.vue?vue&type=template&id=dc9666ec&scoped=true&"
import script from "./ticket_detail.vue?vue&type=script&lang=js&"
export * from "./ticket_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9666ec",
  null
  
)

export default component.exports